import { Button, Modal, ModalBody, ModalFooter, Text } from 'src/components';
import { Model } from 'src/models';

type Props = {
  name: string;
  numStages: number;
  totalMinutesLogged: number;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/**
 * Delete asks first, and removes the time logged against the order too.
 */
export default function DeleteServiceOrderModal({
  name,
  numStages,
  totalMinutesLogged,
  busy,
  onConfirm,
  onClose,
}: Props) {
  const days = Model.ServiceOrder.formatDays(
    Model.ServiceOrder.getDaysUsed(totalMinutesLogged)
  );

  return (
    <Modal size="confirm" onClose={onClose}>
      <ModalBody size="confirm">
        <Text typeface="headline" color="neutral100" as="h2">
          Delete this service order?
        </Text>
        <Text typeface="body.small.regular" color="neutral60">
          {`${name}, its ${numStages} ${
            1 === numStages ? 'stage' : 'stages'
          } and the ${days} days logged against it all go. This cannot be undone.`}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          label="Cancel"
          variant="text"
          colorScheme="black"
          onClick={onClose}
        />
        <Button label="Delete" onClick={onConfirm} disabled={busy} />
      </ModalFooter>
    </Modal>
  );
}
